export default __webpack_public_path__ + "static/nmn-award-2023-dark-white-text-15182f22a7bf477b5e1339896db6bc26.svg";